import React, { ReactNode } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useSidebar } from '../../hooks/useSidebar';
import { useResponsive } from '../../hooks/useResponsive';

interface MasterLayoutProps {
  children: ReactNode;
}

const MasterLayout: React.FC<MasterLayoutProps> = ({ children }) => {
  const { isOpen, toggle, close } = useSidebar(false);
  const { isMobile, isTablet } = useResponsive();

  const shouldShowSidebar = !isMobile && !isTablet;

  return (
    <div className='flex h-screen bg-white dark:bg-slate-900'>
      {/* デスクトップ: 常時表示サイドバー */}
      {shouldShowSidebar && <Sidebar isOpen={true} onClose={close} />}

      {/* モバイル・タブレット: スライドサイドバー */}
      {(isMobile || isTablet) && <Sidebar isOpen={isOpen} onClose={close} />}

      <div className='flex flex-col flex-1 min-w-0'>
        <Header onMenuClick={toggle} />
        <main
          className='flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto'
          style={{
            // モバイル・タブレットでは全幅、デスクトップでは残り幅
            width: shouldShowSidebar ? 'calc(100vw - 256px)' : '100%',
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default MasterLayout;
